var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuBoard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9851 15.0294C39.0151 15.3894 38.9851 15.7644 38.8951 16.1394L33.8401 36.4344C33.4801 37.9494 32.1301 38.9994 30.5701 38.9994H10.8601C8.5951 38.9994 6.99012 36.7794 7.65012 34.6044L13.9651 14.3094C14.4001 12.8994 15.7051 11.9395 17.1751 11.9395H35.6251C37.0651 11.9395 38.2351 12.7944 38.7301 13.9944C38.8801 14.3094 38.9551 14.6694 38.9851 15.0294Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4848 35.43C40.6348 37.365 39.1048 39 37.1698 39H30.5698C32.1298 39 33.4798 37.95 33.8398 36.435L38.8948 16.14C38.9848 15.765 39.0148 15.39 38.9848 15.03L38.9998 15L40.4848 35.43Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5201 16.6951C20.4301 16.6951 20.3401 16.68 20.2501 16.665C19.6501 16.515 19.2752 15.9151 19.4252 15.3001L20.9851 8.82008C21.1351 8.22008 21.7351 7.86009 22.3501 7.99509C22.9501 8.14509 23.3252 8.74505 23.1752 9.36005L21.6152 15.8401C21.4952 16.3501 21.0301 16.6951 20.5201 16.6951Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5702 16.7107C30.4952 16.7107 30.4051 16.7106 30.3301 16.6806C29.7301 16.5456 29.3402 15.9456 29.4602 15.3456L30.8701 8.83568C31.0051 8.22068 31.6051 7.84565 32.2051 7.96565C32.8051 8.10065 33.1951 8.70068 33.0751 9.30068L31.6651 15.8106C31.5601 16.3506 31.0952 16.7107 30.5702 16.7107Z",
    fill: "#111827"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5498 25.125H17.5498C16.9348 25.125 16.4248 24.615 16.4248 24C16.4248 23.385 16.9348 22.875 17.5498 22.875H29.5498C30.1648 22.875 30.6748 23.385 30.6748 24C30.6748 24.615 30.1648 25.125 29.5498 25.125Z",
    fill: "#111827"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0498 31.125H16.0498C15.4348 31.125 14.9248 30.615 14.9248 30C14.9248 29.385 15.4348 28.875 16.0498 28.875H28.0498C28.6648 28.875 29.1748 29.385 29.1748 30C29.1748 30.615 28.6648 31.125 28.0498 31.125Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBoard);
export default __webpack_public_path__ + "static/media/menuBoard.120fe344446dcacc12bc9515a30bf190.svg";
export { ForwardRef as ReactComponent };